import { createContext, useContext } from "react";

/**
 * Who owns ⌘K — Fontaine M34R.
 *
 * `AppShell` mounts the app's ONE production CommandPalette (`ft-cmdk`) and provides `true` here for
 * every authenticated route — and it wraps ALL routes, `/styleguide-v2` included (App.jsx). A page
 * that ships its own palette demo reads this and stands down from the window-level shortcut, so one
 * ⌘K can never open two dialogs. Its trigger and its interaction are untouched.
 *
 * Kept out of CommandPalette.jsx on purpose: a page only needs to ask the question, not to import the
 * production palette and its stylesheet. Nothing but AppShell should provide this.
 */
export const GlobalCommandPaletteContext = createContext(false);

/** @returns {boolean} true when an ancestor already owns the global ⌘K shortcut. */
export const useGlobalCommandPaletteMounted = () => useContext(GlobalCommandPaletteContext);
